import { getError } from '@autobid/strapi-integration/utils/getError'

export function useFetchCategories() {
  const { $trpc } = useNuxtApp()

  const fetchCategories = async (lang: string) => {
    try {
      return await $trpc.auctions.getCategories.query({ lang })
    }
    catch (error) {
      const { message, code, handled } = getError(error)

      if (!handled) {
        throw createError({ statusCode: code, statusMessage: message })
      }

      return null
    }
  }

  return { fetchCategories }
}
